import React from 'react';

type Props = {
    checks: {
        passed: number;
        warning: number;
        failed: number;
    } | null;
    isLoading?: boolean;
};

export default function ServiceableUrlsChecksCell({ checks, isLoading }: Props) {
    return (
        <>
            {!isLoading && checks && [checks.failed, checks.passed, checks.warning].some(v => v > 0) && (
                <div className="checks-stats">
                    <div className="stat-element failed">
                        <span className="stat-name">Failed: </span>
                        <span className="stat-value">{checks.failed}</span>
                    </div>
                    <div className="stat-element warning">
                        <span className="stat-name">Warnings: </span>
                        <span className="stat-value">{checks.warning}</span>
                    </div>
                    <div className="stat-element passed">
                        <span className="stat-name">Passed: </span>
                        <span className="stat-value">{checks.passed}</span>
                    </div>
                </div>
            )}
        </>
    );
}
